import * as React from "react";

const Footer = (props: {children?: React.ReactNode}) => (
    <footer className="ll-footer">
        {props.children}
    </footer>
);

export default Footer;